// extracted by mini-css-extract-plugin
export default {"editorWrapper":"QueryParamEditor_editorWrapper__MDO2U","placeholder":"QueryParamEditor_placeholder__iXOIJ"};